import { AttackRange, DamageType, ItemRarity, Weapon } from 'game/core'
import { ItemUI } from 'game/extended/uis/item_uis'

import image from './woodcutters_axe.png'

export const woodcutters_axe: ItemUI<Weapon> = {
    image,
    label: 'Woodcutters axe',
    value: 20,
    item: {
        key: 'woodcutters_axe',
        type: 'weapon',
        rarity: ItemRarity.Common,
        stats: {
            strength: 15,
            health: 10
        },
        two_handed: false,
        category: 'axe',
        damageType: DamageType.Melee,
        range: AttackRange.Melee,
        energy: 2,
        damage: 8
    }
}
